export function appendParams(url, search) {
  const query = (search || "").replace(/^\?/, "");
  if (!query) return url;
  return url + (url.includes("?") ? "&" : "?") + query;
}
